import React, { useCallback } from "react";

import { TireMaterialConfig } from "fe-shared/src/types/domain";
import { Errors } from "fe-shared/src/types/common";
import { TextInput } from "fe-shared/src/components";

import styles from "../RetreadingTransactionFormDialog.module.scss";

interface Props {
  id: string;
  keyPrefix: string;
  label: string;
  inputColLabel: string;
  estimatedColLabel: string;
  materials: TireMaterialConfig[];
  updateValue: (key: string, value: unknown, isValidated?: boolean) => void;
  onBlur: (materialCode: string) => void;
  errors: Errors;
  values: Record<string, number>;
  siblingValidation: Record<string, boolean>;
  estimatedValues: Record<string, number>;
}

const MaterialsTable = ({
  id,
  materials,
  keyPrefix,
  label,
  inputColLabel,
  estimatedColLabel,
  errors,
  values,
  siblingValidation,
  estimatedValues,
  updateValue,
  onBlur,
}: Props) => {
  const getValueKey = useCallback(
    (materialCode: string) => `${keyPrefix}.${materialCode}`,
    [keyPrefix]
  );
  const removeValue = (materialCode: string) => {
    const { [materialCode]: removed, ...rest } = values;

    updateValue(keyPrefix, rest, true);
  };

  return (
    <table id={id}>
      <thead>
        <tr className={styles.dialogTableHeader}>
          <th className={styles.dialogTableHeaderLabel}>{label}</th>
          <th>
            <span className={styles.dialogTableHeaderInputLabel}>
              {inputColLabel}
            </span>
          </th>
          <th>{estimatedColLabel}</th>
        </tr>
      </thead>
      <tbody className={styles.dialogTableBody}>
        {materials.map((material) => {
          const materialCode = material.code;
          const baseKey = `${id}-${materialCode}`;
          const valueKey = getValueKey(materialCode);
          const isSiblingError = siblingValidation[materialCode];
          const isError = !!errors[valueKey] || isSiblingError;

          return (
            <tr key={baseKey}>
              <td>{material.name}</td>
              <td className={styles.dialogTableData}>
                <TextInput
                  id={`${baseKey}-input`}
                  min="0"
                  max="9999999999"
                  type="number"
                  placeholder="0"
                  value={values[materialCode] || ""}
                  onChange={(e, v) => {
                    if (v !== "") {
                      updateValue(valueKey, Number(v), true);
                    } else {
                      removeValue(materialCode);
                    }
                  }}
                  onBlur={() => onBlur(materialCode)}
                  isError={isError}
                  inputClassName={styles.formTableInput}
                  wrapperClassName={styles.formTableWrapper}
                  width="80px"
                />
              </td>
              <td width="82" className={styles.dialogTableData}>
                {estimatedValues[materialCode] || 0}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default MaterialsTable;
